<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="halftitlepage">
<p class="SP"> </p>
<p class="TPHT"><span aria-label="xiii" id="pg_xiii" role="doc-pagebreak">Just Universities</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?162e9786